module.exports = __webpack_public_path__ + "img/b4290c2.jpg";